export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return

  const { appAuthorizationHeader } = useAppAuthorizationHeader()

  if (appAuthorizationHeader && appAuthorizationHeader.Authorization) return

  try {
    await $fetch('/customer/refresh-token', {
      server: false,
      method: 'POST',
      credentials: 'include',
      baseURL: useRuntimeConfig().public.apiBaseURL,
      body: {
        client: useRuntimeConfig().public.client,
      },
    })
  } catch {
    return navigateTo({
      path: usePagePath('login'),
      query: {
        ...(to.fullPath !== usePagePath('self-service') && {
          redirect: to.fullPath,
        }),
      },
    })
  }

  return
})
